import * as React from 'react';
import * as styles from './styles.css';
import { Header0 } from '@cian/ui-kit';

export interface ISearchBlockProps {
  mainFiltersWidget: React.ReactElement;
  submitBlock: React.ReactElement;
}

export const SearchBlock: React.FC<ISearchBlockProps> = props => {
  const { mainFiltersWidget, submitBlock } = props;

  return (
    <div className={styles['container']}>
      <div className={styles['title-container']}>
        <div className={styles['title']}>
          <Header0 as="h1" color="white_100">
            Подбор риелтора от Циан
          </Header0>
        </div>
      </div>
      <div className={styles['wrapper']}>
        <div className={styles['header_container']}>
          <div className={styles['wrapper_label']}>{mainFiltersWidget}</div>
          <div className={styles['wrapper_button']}>{submitBlock}</div>
        </div>
      </div>
    </div>
  );
};

SearchBlock.displayName = 'SearchBlock';
